import {Box, Typography} from "@mui/material";
import {colors, borders} from "./colors";

const StatCard = ({label, value, icon, accent, sx}) => {
  return (
      <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            border: borders.default,
            borderRadius: borders.radius.full,
            padding: "6px 16px",
            backgroundColor: colors.white,
            ...sx,
          }}
      >
        {accent && (
            <Box sx={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: accent,
              flexShrink: 0,
            }}/>
        )}
        <Typography sx={{fontSize: "13px", color: colors.textSecondary, fontWeight: 500, whiteSpace: "nowrap"}}>
          {label}
        </Typography>
        <Typography sx={{fontSize: "14px", color: colors.textPrimary, fontWeight: 700}}>
          {value}
        </Typography>
      </Box>
  );
};

export default StatCard;
